import { paid } from "./appData";
export function earningTime(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (typeof value === "string" && /^\d{10,13}$/.test(value)) return Number(value);
  return Date.parse(String(value || "")) || 0;
}
export function earningMonth(value) {
  const at = earningTime(value);
  if (!at) return "";
  const date = new Date(at);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}`;
}
export function earningMonthLabel(key, full = false) {
  if (!key) return "Undated";
  const [year,month] = key.split("-").map(Number);
  return new Date(year,month-1,1).toLocaleDateString("en-GB",{month:"long",...(full || year !== new Date().getFullYear() ? {year:"numeric"} : {})});
}
const numeric = value => Number.isFinite(Number(value)) ? Number(value) : 0;
export function earningsRows(list, zarPerUsd) {
  return list.map(row => {
    const currency = String(row.currency || "ZAR").toUpperCase();
    const factor = currency === "USD" ? numeric(zarPerUsd) : 1;
    const rawNet = numeric(row.amount ?? row.settledAmount ?? row.saleAmount);
    const rawGross = numeric(row.grossAmount ?? rawNet);
    const hasGross = row.grossAmount !== undefined && row.grossAmount !== null;
    const rawRate = typeof row.commissionRate === "number" && Number.isFinite(row.commissionRate) ? row.commissionRate : null;
    return {
      ...row,
      at:earningTime(row.createdAt),
      month:earningMonth(row.createdAt),
      title:row.jobTitle || "Job payment",
      counterparty:row.clientName && row.clientName !== "Client" ? row.clientName : "",
      currency,
      net:rawNet*factor,
      gross:rawGross*factor,
      fee:hasGross ? (rawGross-rawNet)*factor : null,
      // Some records store the combined hirer + creative commission rate.
      // Only gross minus net is the fee taken from this creative's earnings.
      feeRate:hasGross && rawGross > 0 ? ((rawGross-rawNet)/rawGross)*100 : rawRate === null ? null : rawRate > 1 ? rawRate : rawRate*100,
      hasGross,
      settled:paid(row),
    };
  }).sort((a,b)=>b.at-a.at);
}
export function earningsTotals(entries) {
  return entries.reduce((total,entry)=>{
    total.net += entry.net;
    total[entry.settled ? "paid" : "held"] += entry.net;
    total.count += 1;
    return total;
  },{net:0,paid:0,held:0,count:0});
}
export const earningsMoney = value => "R" + Number(value || 0).toLocaleString("en-ZA",{maximumFractionDigits:2});

